import { PurchaseInvoiceHeaderDeliveryItem, PurchaseInvoiceHeaderExtraItem } from '../purchasing';

export interface StockItemCosts {
  id: string;
  stockNo: string;
  dateCreated: Date;
  createdById: string;
  pricePerUnit: number;
  purchaseOrderNo: string;
  supplier: string;
  orderDate: Date;
  purchasePrice: number;
  purchaseInvoiceNo: number;
  purchaseInvoiceDate: Date;
  purchaseInvoiceQuantity: number;
  purchaseInvoiceValue: number;
  purchaseInvoicePrice: number;
  purchaseInvoiceDeliveryValue: number;
  purchaseInvoiceExtraValue: number;
  currencyCode: string;
  exchangeRate: number;
  purchaseInvoiceTotalValue: number;
  purchaseInvoiceSterlingTotalValue: number;
  purchaseInvoicePricePerUnit: number;
  unitOfMeasure: string;
  baseCurrency: string;

  purchaseInvoiceHeaderDeliveryItems: PurchaseInvoiceHeaderDeliveryItem[];
  purchaseInvoiceHeaderExtraItems: PurchaseInvoiceHeaderExtraItem[];
}
